// Display helpers for the brand support shortcuts. Pure functions only.

export function firstLetter(name) {
    const trimmed = typeof name === 'string' ? name.trim() : ''
    const letter = Array.from(trimmed)[0]
    return letter ? letter.toUpperCase() : '?'
}

function plural(count, one, few, many) {
    const mod10 = count % 10
    const mod100 = count % 100
    if (mod10 === 1 && mod100 !== 11) return one
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few
    return many
}

function chatsWord(count) {
    return plural(count, 'чат ждёт', 'чата ждут', 'чатов ждут')
}

export function waitingText(company) {
    if (company.waiting === null) return 'Число сейчас недоступно'
    return `${company.waiting} ${chatsWord(company.waiting)} оператора`
}

export function companiesWord(count) {
    return plural(count, 'компания', 'компании', 'компаний')
}

const TIME_OPTIONS = { hour: '2-digit', minute: '2-digit', second: '2-digit' }

// Backend times are UTC instants; they are shown in the device's local zone.
export function formatTime(ms) {
    if (!Number.isFinite(ms)) return '—'
    return new Intl.DateTimeFormat('ru-RU', TIME_OPTIONS).format(new Date(ms))
}
